




























import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import Modal from '@/components/Modal.vue'
import BaseButton from '@/components/BaseButton.vue'

@Component<FeedbackModal>({
  components: {BaseButton, Modal}
})
export default class FeedbackModal extends Vue {
  @Prop({type: String, default: 'small'}) public modalSize ?: string
  @Prop({type: Boolean, default: true}) private showModalBg !: boolean

  private feedback = ''
  private wordLimit = 300

  private get wordLeft() {
    return this.wordLimit - this.feedback.length
  }

  private get buttonDisabled() {
    return this.wordLeft < 0
  }
}
